var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconPlayButton = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 0C8.971 0 0 8.972 0 20s8.971 20 20 20 20-8.972 20-20S31.029 0 20 0zm7.95 20.7l-11.666 7.5c-.136.09-.294.133-.45.133-.137 0-.276-.034-.4-.101-.268-.147-.434-.427-.434-.732v-15c0-.305.166-.585.435-.732.263-.145.594-.136.85.031l11.666 7.5c.238.153.382.418.382.701s-.144.548-.382.7z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPlayButton, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_play-button.6d6435fd.svg";
export { ForwardRef as ReactComponent };